/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
import Swiper, { Pagination, Autoplay } from 'swiper';

class UspSlider {
  constructor(el) {
    this.el = el;
  }

  init() {
    Swiper.use([Pagination, Autoplay]);

    const slider = new Swiper(this.el, {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      allowTouchMove: true,
      spaceBetween: 12,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    this.slider = slider;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.usps-mobile .swiper');

  sliders.forEach((el) => {
    new UspSlider(el).init();
  });
});
